import React, { useState, useMemo, useEffect } from "react";
import { Box, Button, Popover, Stack, Tooltip } from "@mui/material";
import { DateRangePicker } from "react-date-range";
import { format, isValid, endOfDay, addDays, isSameDay } from "date-fns";
import { enUS } from "date-fns/locale";
import { CalendarToday } from "@mui/icons-material";
import "./CustomDateRangePicker.css";

const CustomDateRangePicker = ({ dateRange, setDateRange, defaultDateRange, staticRanges = [], maxDate = false }) => {

	const [anchorEl, setAnchorEl] = useState(null);
	const [selectedLabel, setSelectedLabel] = useState("");
	const [selectedDate, setSelectedDate] = useState([
			{
				startDate: dateRange?.start_date,
				endDate: dateRange?.end_date,
				key: "selection",
			},
		]);
	const [selectedRange, setSelectedRange] = useState([
			{
				startDate: dateRange?.start_date,
				endDate: dateRange?.end_date,
				key: "selection",
			},
		]);

		const matchStaticRange = (startDate, endDate) => {
		for (const rangeObj of staticRanges) {
			const { startDate: staticStart, endDate: staticEnd } = rangeObj.range();
			if (isSameDay(staticStart, startDate) && isSameDay(staticEnd, endDate)) {
				return rangeObj.label;
			}
		}
		return null;
	};
useEffect(() => {
	if (dateRange?.start_date && dateRange?.end_date) {
		setSelectedDate([
			{
				startDate: new Date(dateRange.start_date),
				endDate: new Date(dateRange.end_date),
				key: "selection",
			},
		]);
		setSelectedRange([
			{
				startDate: new Date(dateRange.start_date),
				endDate: new Date(dateRange.end_date),
				key: "selection",
			},
		]);
		const matchedLabel = matchStaticRange(new Date(dateRange.start_date),new Date(dateRange.end_date));
		if (matchedLabel) {
			setSelectedLabel(matchedLabel);
		} else {
			setSelectedLabel(null);
		}
	}
}, [dateRange]);

	// ---------- Event handlers ----------
	const handleClick = (event) => setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);


	const handleRangeChange = (item) => {
		setSelectedDate([item.selection]);
	};

const handleApply = (item) => {
		const startDate = selectedDate[0]?.startDate;
		const endDate = selectedDate[0]?.endDate;
		setSelectedRange(selectedDate);
		setDateRange({start_date: startDate, end_date: endDate})

		const matchedLabel = matchStaticRange(startDate, endDate);
		if (matchedLabel) {
			setSelectedLabel(matchedLabel);
		} else {
			setSelectedLabel(null);
		}
		handleClose();
	};

	const handleCancel = () => {
		setSelectedDate([{
				startDate: dateRange?.start_date,
				endDate: dateRange?.end_date,
				key: "selection",
			}])
		setSelectedRange([{
				startDate: dateRange?.start_date,
				endDate: dateRange?.end_date,
				key: "selection",
			}])
		setDateRange({start_date: dateRange?.start_date, end_date: dateRange?.end_date})
		handleClose()
	};

	// ---------- Popover state ----------
	const open = Boolean(anchorEl);
	const id = open ? "date-range-popover" : undefined;
	const range = selectedRange[0];
	const buttonLabel = selectedLabel
			? selectedLabel
			: `${format(range.startDate, "MMM d, yyyy")} - ${format(range.endDate, "MMM d, yyyy")}`;

	// ---------- JSX (your same structure + Apply/Reset buttons) ----------
	return (
		<Box key={dateRange}>
			<Button
				variant="outlined"
				onClick={handleClick}
				color="secondary"
				sx={{
					borderRadius: "4px",
					width: "100%",
					p: "7px",
					fontWeight: 400,
					textTransform: "capitalize",
				}}>
				<CalendarToday sx={{ height: 20, width: 20, mr: 1, flexShrink: 0 }} />
				<Tooltip title={buttonLabel} arrow>
					<Box
						component="span"
						sx={{
							textOverflow: "ellipsis",
							overflow: "hidden",
							whiteSpace: "nowrap",
							display: "inline-block",
							maxWidth: "90%",
						}}>
						{buttonLabel}
					</Box>
				</Tooltip>
			</Button>

			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleCancel}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				ModalProps={{ keepMounted: false }}>
				<Box display="flex" flexDirection="column">
					<Box display="flex">
						<DateRangePicker
							onChange={handleRangeChange}
							moveRangeOnFirstSelection={false}
							months={2}
							ranges={selectedDate}
							direction="horizontal"
							showSelectionPreview
							locale={enUS}
							maxDate={new Date()}
							staticRanges={staticRanges}
							inputRanges={[]}
						/>
					</Box>

					<Stack direction="row" justifyContent="flex-end" spacing={1} borderTop="1px solid #eee" p={1}>
						<Button onClick={handleCancel} variant="outlined" size="small">
							Cancel
						</Button>
						<Button onClick={handleApply} variant="contained" size="small">
							Apply
						</Button>
					</Stack>
				</Box>
			</Popover>
		</Box>
	);
};

export default CustomDateRangePicker;
